/**
 *
 */

var Project = (function($) {
  function initProject() {
    // Limpia listeners anteriores
    $(document).off("click.projectHandlers");
    $(".project-hero__link").off("click.projectHandlers");

    // Toggle panel al hacer clic en el link
    $(".project-hero__link").on("click.projectHandlers", function(e) {
      e.preventDefault();

      const $body = $("body");
      const $info = $(".project-info");

      if ($body.hasClass("project-opened")) {
        // Si ya está abierto → cerramos
        $info.css("left", "100%");
        $body.removeClass("project-opened");
      } else {
        // Si está cerrado → abrimos
        $info.css("left", "0");
        $body.addClass("project-opened");
      }
    });

    // Cerrar al hacer clic fuera del panel
    $(document).on("click.projectHandlers", function(event) {
      const $body = $("body");
      const $info = $(".project-info");

      if (
        $body.hasClass("project-opened") &&
        !$(event.target).closest(".project-info-wrapper, .project-hero__link")
          .length
      ) {
        $info.css("left", "100%");
        $body.removeClass("project-opened");
      }
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".single-project").length) {
      return;
    }

    initProject();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Project.init);
